import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {Button} from "@material-ui/core";
import PropTypes from "prop-types";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import useProgressiveInput from "../../../../../../../../../../hooks/useProgressiveInput";
import * as actions from "../../../../../../../../../../store";
import {updateObject} from "../../../../../../../../../../shared/utils/updateObject";
import AutocompleteWithoutIcon
    from "../../../../../../../../../ui/autocompletes/autocomplete-without-icon/AutocompleteWithoutIcon";
import GenericDialog from "../../../../../../../../../ui/dialogs/generic-dialog/GenericDialog";
import DefaultSelect from "../../../../../../../../../ui/inputs/selects/default-select/DefaultSelect";
import {getHowManyFiltersApplied} from "../../../../../../../../../../shared/utils/utils";

const ServiziDetailsFilterDialog = (props) => {
    const dispatch = useDispatch();
    const [tagAutocompleteInput, setTagAutocompleteInput] = useState("");
    const [setTimeoutTagsAutocomplete] = useProgressiveInput(
        (searchText) => dispatch(actions.fetchSimTagsAutocomplete(searchText)), 1000);
    const filterData = useSelector(state => state.contrattoDigitaleReducer.apnSimFilterData.data);
    const loading = useSelector(state => state.contrattoDigitaleReducer.apnSimFilterData.loading);
    const [currentFilters, setCurrentFilters] = useState(props.filter)
    const filterDataTags = useSelector((state) => state.simReducer.filterData.tags);

    const handleAutocompleteInputChange = (e) => {
        let inputValue = e.target.value;
        setTagAutocompleteInput(inputValue);
        if (inputValue.length > 0) {
            setTimeoutTagsAutocomplete(inputValue);
        }
    }

    const handleChange = (e, name) => {
        setCurrentFilters(prevState => updateObject(prevState, {
            [name]: updateObject(prevState[name], {value: e.target.value})
        }))
    }

    const changeTags = (name, value) => {
        setCurrentFilters(prevState => updateObject(prevState, {
            [name]: updateObject(prevState[name], {value: value})
        }))
    }

    const handleApplicaClick = () => {
        props.handleFilterSearch(currentFilters)
        props.handleDialogClose();
    }

    const dialogContent = (
        <>
            <Typography className="mb-24" variant="h5">Filtri</Typography>

            <Grid container
                  spacing={2}
                  justifyContent="space-between"
                  alignItems="center">
                <Grid item xs={12} sm={4}>
                    <Typography variant={"subtitle1"}>Tag associati</Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <AutocompleteWithoutIcon placeholder="Cerca tag"
                                             bgColor="#7c92a5"
                                             searchText={tagAutocompleteInput}
                                             setSearchText={handleAutocompleteInputChange}
                                             allItems={filterDataTags}
                                             selectedItems={currentFilters.tags.value}
                                             setSelectedItems={(value) => changeTags("tags", value)}/>
                </Grid>
            </Grid>

            <Grid container
                  spacing={2}
                  justifyContent="space-between"
                  alignItems="center">
                <Grid item xs={12} sm={4}>
                    <Typography variant={"subtitle1"}>Tipo APN</Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <DefaultSelect
                        menuItems={filterData.apnTypes}
                        handleOnChange={(e) => handleChange(e, "tipoApn")}
                        fullWidth
                        label="Seleziona"
                        value={currentFilters.tipoApn.value}
                    />
                </Grid>
            </Grid>

            <Grid container
                  spacing={2}
                  justifyContent="space-between"
                  alignItems="center">
                <Grid item xs={12} sm={4}>
                    <Typography variant={"subtitle1"}>Nome APN</Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <DefaultSelect
                        menuItems={filterData.apnNames}
                        handleOnChange={(e) => handleChange(e, "nomeApn")}
                        fullWidth
                        label="Seleziona"
                        value={currentFilters.nomeApn.value}
                    />
                </Grid>
            </Grid>

        </>
    );

    const dialogActions = (
        <Grid container
              justifyContent="space-between">
            <Button color="primary"
                    variant="outlined"
                    onClick={props.handleDialogClose}>
                Annulla
            </Button>

            <Button color="primary"
                    variant="contained"
                    disabled={!getHowManyFiltersApplied(currentFilters)}
                    onClick={handleApplicaClick}>
                Applica {getHowManyFiltersApplied(currentFilters) !== 0 ? ` (${getHowManyFiltersApplied(currentFilters)})` : ""}
            </Button>
        </Grid>
    );

    return(
        <GenericDialog
            open={props.open}
            loading={loading}
            handleDialogClose={props.handleDialogClose}
            dialogContent={dialogContent}
            handleDialogCloseButton={props.handleDialogClose}
            dialogActions={dialogActions}
            dialogWidth={"md"}
        />
    )
}

ServiziDetailsFilterDialog.propTypes = {
    filter: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
    handleFilterSearch: PropTypes.func.isRequired,
}

export default ServiziDetailsFilterDialog;